import { useEffect } from 'react';
import { replaceDeliveryOptionBtn } from '../functions';

const ResetSavedData = () => {
	useEffect( () => {
		if ( window.performance ) {
			if ( 1 === performance.navigation.type ) {
				localStorage.removeItem( 'digital-code-saved-data' );
			} else {
				setData();
			}
		}
	}, [] );

	function setElementData( key, data ) {
		const el = document.getElementById( 'react-digital-code-delivery-options-' + key );
		el.setAttribute( 'data-selected-distribution-method', data.selectedDistributionMethod );
		el.setAttribute( 'data-selected-emails', JSON.stringify( data.emails ) );
		el.setAttribute( 'data-is-selected', 'true' );
	}

	function setData() {
		let data = localStorage.getItem( 'digital-code-saved-data' );
		if ( ! data ) {
			return null;
		}
		data = JSON.parse( data );
		Object.keys( data ).map( key => { // eslint-disable-line array-callback-return
			replaceDeliveryOptionBtn( key );
			setElementData( key, data[ key ] );
		} );
	}

	return null;
};

export default ResetSavedData;
